"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButtonGroup = exports.ToggleItem = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

exports.ToggleItem = utils_2.forwardRef(function ToggleItem(props, ref) {
  var children = props.children,
      itemsNumber = props.itemsNumber,
      index = props.index,
      selected = props.selected,
      _onClick = props.onClick,
      caption = props.caption;
  var caseCSS = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tbackground: ", ";\n\n\t\tborder: 1px solid ", ";\n\t\tbox-sizing: border-box;\n\t\tcursor: pointer;\n\t\tdisplay: flex;\n\t\tpadding: 1em;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tfont-size: 0.875em;\n\t\tfont-weight: 600;\n\t\tjustify-content: center;\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t\tborder: 1px solid ", ";\n\t\t\tbox-shadow: inset 0 0 0 1px ", ";\n\t\t}\n\n\t\t", "\n\t\t", "\n\t\t", "\n\t\t", "\n\t"], ["\n\t\tbackground: ", ";\n\n\t\tborder: 1px solid ", ";\n\t\tbox-sizing: border-box;\n\t\tcursor: pointer;\n\t\tdisplay: flex;\n\t\tpadding: 1em;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tfont-size: 0.875em;\n\t\tfont-weight: 600;\n\t\tjustify-content: center;\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t\tborder: 1px solid ", ";\n\t\t\tbox-shadow: inset 0 0 0 1px ", ";\n\t\t}\n\n\t\t", "\n\t\t", "\n\t\t", "\n\t\t", "\n\t"])), foundation_1.colors.white, foundation_1.colors.graphical.strokes, foundation_1.colors.graphical.bgLightGrey, foundation_1.colors.primary.green, foundation_1.colors.primary.green, index === 0 && 'border-top-left-radius: 3px; border-bottom-left-radius: 3px; border-right: solid 1px transparent;', index === itemsNumber - 1 && 'border-top-right-radius: 3px; border-bottom-right-radius: 3px; border-left: solid 1px transparent;', selected && "border: solid 1px " + foundation_1.colors.primary.green + "; font-weight: 800; background: " + foundation_1.colors.graphical.bgLightGrey + "; box-shadow: inset 0 0 0 1px " + foundation_1.colors.primary.green + ";", caption && "font-weight: 800;");
  var captionStyle = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\tmargin-top: 4px;\n\t\tfont-weight: 600;\n\t"], ["\n\t\tmargin-top: 4px;\n\t\tfont-weight: 600;\n\t"])));
  return (0, _core.jsx)(lseds_1.lseds.div, {
    css: caseCSS,
    onClick: function onClick() {
      return _onClick();
    }
  }, (0, _core.jsx)(lseds_1.lseds.div, null, children), caption && (0, _core.jsx)(lseds_1.lseds.div, {
    css: captionStyle
  }, caption));
});
exports.ToggleButtonGroup = utils_2.forwardRef(function ToggleButtonGroup(props, ref) {
  var onChange = props.onChange,
      selected = props.selected;

  var _a = React.useState(-1),
      selectedIndex = _a[0],
      setSelectedIndex = _a[1];

  var container = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: flex-start;\n\t"], ["\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: flex-start;\n\t"])));

  var onClickAction = function onClickAction(index, child) {
    setSelectedIndex(index);

    if (onChange) {
      if (child && child.props && child.props.value) {
        onChange(child.props.value);
      }
    }
  };

  return (0, _core.jsx)(lseds_1.lseds.div, {
    css: container
  }, React.Children.map(props.children, function (child, index) {
    // @ts-ignore
    return React.cloneElement( // @ts-ignore
    child, {
      selected: selectedIndex !== -1 ? index === selectedIndex : child.props.selected,
      index: index,
      caption: child.props.caption,
      onClick: function onClick() {
        return onClickAction(index, child);
      },
      itemsNumber: React.Children.count(props.children)
    });
  }));
});

if (utils_1.isDev) {
  exports.ToggleButtonGroup.displayName = 'ToggleButtonGroup';
}

var templateObject_1, templateObject_2, templateObject_3;